<script setup lang="ts">
import { ref, watch } from 'vue';
import { deleteGroupInHierarchy } from '@/api/GroupApi';
import type { Group } from '@/models/Group';

const props = defineProps<{ isOpen: boolean; group: Group | null }>();
const emit = defineEmits(['update:isOpen', 'group-deleted']);

const isOpen = ref(props.isOpen);
const deleteError = ref('');

const cancel = () => {
  isOpen.value = false;
  emit('update:isOpen', false);
};

const confirm = async () => {
  if (!props.group) {
    return;
  }
  try {
    await deleteGroupInHierarchy(props.group.uuid);
    emit('group-deleted');
    cancel();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error('Failed to delete group:', error);
    deleteError.value = error;
  }
};

watch(
  () => props.isOpen,
  (newVal) => {
    isOpen.value = newVal;
    deleteError.value = '';
  },
);
</script>

<template>
  <v-dialog v-model="isOpen" max-width="600" @click:outside="cancel">
    <v-card>
      <v-card-title>{{ $gettext('Confirm Deletion') }}</v-card-title>
      <v-card-text>
        <p>{{ $gettext('Are you sure you want to delete this group?') }}</p>
        <p>
          <b>{{ group?.name }}</b>
        </p>
      </v-card-text>
      <v-alert v-if="deleteError" class="mx-2" type="error">{{
        deleteError
      }}</v-alert>
      <v-card-actions>
        <v-btn color="blue darken-1" variant="text" @click="cancel">{{
          $gettext('Close')
        }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" variant="text" @click="confirm">{{
          $gettext('Delete')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
